import * as React from "react";
import PropTypes from "prop-types";
import { useDemoData } from "@mui/x-data-grid-generator";
import { createTheme, styled } from "@mui/material/styles";
import SearchBar from "material-ui-search-bar";
import * as style from "../../style/style.css";
import { makeStyles } from "@material-ui/core/styles";

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { connect } from "react-redux";
import { tableCellClasses } from "@mui/material";
import ExportExcel from "../../../../common/components/ExportExcel";
import Grid from "@mui/material/Grid";
import NtnRow from "./NtnRow";

const defaultTheme = createTheme();

function Item(props) {
  return null;
}

Item.propTypes = { children: PropTypes.node };

const useStyles = makeStyles((theme) => ({
  tableCellStyle: {
    justifyContent: "center",
    textAlign: "center",
  },
  table: {
    marginTop: "10px",
    marginBottom: "30px",
  },
}));

const NtnResultForm = (props) => {
  const style = useStyles();
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: props.theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const { data } = useDemoData({
    dataSet: "Commodity",
    rowLength: 50,
    maxColumns: 6,
  });

  const [searchText, setSearchText] = React.useState("");
  const [rows, setRows] = React.useState(data.rows);

  React.useEffect(() => {
    setRows(props.shipments ? props.shipments : []);
  }, [props.shipments]);

  const requestSearch = (searchText) => {
    const filteredRows = props.shipments.filter((row) => {
      return (
        row.idEquipment?.toLowerCase().includes(searchText.toLowerCase()) ||
        row.port?.toLowerCase().includes(searchText.toLowerCase()) ||
        row.customsStatus?.toLowerCase().includes(searchText.toLowerCase()) ||
        row.gateInDateTime?.toLowerCase().includes(searchText.toLowerCase())
      );
    });
    setRows(filteredRows);
  };

  const cancelSearch = () => {
    setSearchText("");
    requestSearch(searchText);
  };
  if (rows.length > 0) {
    return (
      <TableContainer component={Paper}>
        <Grid container spacing={5}>
          <Grid item xs={12} md={5}>
            <SearchBar
              style={{ width: 300, border: "1px solid #232f66" }}
              placeholder={"Filtrer"}
              value={searchText}
              onChange={(searchText) => requestSearch(searchText)}
              onCancelSearch={() => cancelSearch()}
            />
          </Grid>
          <Grid xs={12} md={4}></Grid>
          <Grid item xs={3} textAlign={"right"}>
            <ExportExcel ExcelData={rows} fileName={"liste des conteneurs"} />
          </Grid>
        </Grid>

        <Table
          stickyHeader
          aria-label="collapsible table"
          className={style.table}
        >
          <TableHead >
            <TableRow>
              <StyledTableCell className={style.tableCellStyle} />
              <StyledTableCell className={style.tableCellStyle}>
                Numéro de conteneur
              </StyledTableCell>
              <StyledTableCell className={style.tableCellStyle}>
                Port
              </StyledTableCell>
              <StyledTableCell className={style.tableCellStyle}>
                Statut douanier
              </StyledTableCell>
              <StyledTableCell className={style.tableCellStyle}>
                ETA - ETD
              </StyledTableCell>
              <StyledTableCell className={style.tableCellStyle}>
                Date MAJ
              </StyledTableCell>
              <StyledTableCell className={style.tableCellStyle}>
                Opérations
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <NtnRow key={row.name} row={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  } else {
    return <></>;
  }
};

const mapStateToProps = (state) => {
  return {
    shipmentByUser: state.ShipmentByUserReducer,
    shipment: state.ShipmentReducer,
  };
};

export default connect(mapStateToProps, null)(NtnResultForm);
